import { useContext } from "react";
import { SiteMetadataContext } from "../context/SiteMetadataContext";

export const useSiteMetadata = () => {
  const context = useContext(SiteMetadataContext);
  if (!context) {
    throw new Error("useSiteMetadata must be used within SiteMetadataProvider");
  }
  return context;
};
